import { render, staticRenderFns } from "./ClientRecipientDialog.vue?vue&type=template&id=55ef8fb0&"
import script from "./ClientRecipientDialog.vue?vue&type=script&lang=js&"
export * from "./ClientRecipientDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports